export const LENDER_RESPONSE_TIMES = {
  default: '10-15',
  propensio: '30-45',
};
